import {Link, useLocation, useParams} from 'react-router-dom';
import React, {useEffect, useState} from "react";
import DOMPurify from 'dompurify';
import {Formik, Form, Field, ErrorMessage, FormikValues, FormikHelpers} from 'formik';
import { NavHashLink, HashLink } from 'react-router-hash-link';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';
import '../scss/archive_articles.scss';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import * as Yup from 'yup'

const SingleBlogger = () =>{
    const [data, setData] = useState([]);
    const {slug} = useParams();
    const location = useLocation();
    let section = location.pathname.match(/[^\/]+/g);

    useEffect(() => {
        fetch( global.config.api + `/?method=get_article&slug=${slug}&category=${section[0]}`)
            .then(response => response.json())
            .then(json => {
                if (json && json.valid) {
                    setData(json);
                    //console.log(json.similar_feed);
                    //console.log(`/?method=get_article&slug=${slug}` + ' - ' + slug);
                } else {
                    console.error('Invalid data structure', json);
                }
            })
            .catch(error => console.error('Error fetching data:', error));
    }, [slug]);

    let similar_feed = data.similar_feed;
    // let similar_feed_short = similar_feed.slice(0, 2);

    const closeSearchBox = () =>{
        let node = document.getElementById('search_form');
        if (node.classList.contains("search_results")){
            node.classList.remove('search_results');
        }
        //console.log('closeSearchBox ')
    }

    const renderStars = (rating) => {
        ///console.log('loaded');
        const full_stars  = Math.floor( rating );
        const half_stars  = Math.ceil( rating - full_stars ) + full_stars;

        let all_stars = [];
        //console.error( full_stars + ' ' + half_stars + ' ' + empty_stars);
        for (let i = 1; i <= 5; i++) {
            if( full_stars >= i){
                all_stars[i] = 'full';
            } else if ( half_stars >= i ){
                all_stars[i] = 'half';
            } else {
                all_stars[i] = 'empty';
            }
        }
        let rating_float = parseFloat(rating) + 0.001 ;

        // rating.toFixed(1);
        return (<div className="star-rating"><span className="rating-text">{rating_float.toFixed(1)}</span>
                {all_stars.map(star => (
                    <div className={'star star-' + star} aria-hidden="true"></div>
                ))}
            </div>
        );
    }

    const getPostThumbnail = (avatar) => {
        return avatar == '' ? '/wp-content/plugins/blog_tools/images/image_placeholder.png' : avatar;
    }

    const getProcentChangeClass = (change) => {
        return change <= 0 ? 'red' : 'green';
    };

    const checkHTML = (string) => {
        return DOMPurify.sanitize(string, { USE_PROFILES: { html: true } });
    }

    const buildComments = (comments) => {

        if(!Array.isArray(comments)) {
            return '';
        } else {
            return (
                <ul className="single_article_comments_new_comments">
                    {comments.map( item => (
                        <li className="single_article_comments_new_comments_wraper">
                            <div className="single_article_comments_new_comments_wraper_header">
                                <div className="single_article_comments_new_comments_wraper_header_icon">
                                    <img  src={item.avatar_url} alt={item.comment_author}/>
                                </div>
                                <div className="single_article_comments_new_comments_wraper_header_name_date">
                                    <div className="single_article_comments_new_comments_wraper_header_name">
                                        {item.comment_author}
                                    </div>
                                    <div className="single_article_comments_new_comments_wraper_header_date">
                                        {item.comment_date}
                                    </div>
                                </div>
                            </div>
                            <div className="single_article_comments_new_comments_wraper_content" dangerouslySetInnerHTML={{__html: checkHTML(item.comment_content)}}></div>
                        </li>
                        )
                    )
                    }
                </ul>
            );
        }
    }

    const validationSchema = Yup.object().shape({
        user_name: Yup.string(),
        user_email: Yup.string().email('Не корректный емейл').required('Укажите емейл'),
        comment: Yup.string().min(300, 'Комментарий должен быть не меньше 300 символов').required('Напишите комментарий'),
    });


    const CommentForm = () => (
            <Formik
                initialValues={{
                    user_name: '',
                    user_email: '',
                    comment: '',
                }}
                validationSchema={validationSchema}
                // onSubmit={(data) =>{console.log(data)}}
                onSubmit={(values, actions) => {
                    fetch( global.config.api + `/?method=save_comment&slug=${slug}&user_name=${values.user_name}&user_email=${values.user_email}&comment=${values.comment}`)
                        .then(response => response.json())
                        .then(json => {
                            let node = document.getElementById('comment_submit_form');
                            if (json && json.success) {
                                //setData(blogger);
                                node.innerHTML = '<div class="comment_success">Спасибо, Ваш коментарий находится на модерации</div>'
                                // console.log(json.success);
                            } else {
                                node.innerHTML = '<div class="comment_failed">Упс, ошибка данных</div>'
                                console.error('Invalid data structure', json);
                            }
                        })
                        .catch(error => console.error('Error fetching data:', error));
                }}
            >
                {props => (
                    <div id="comment_submit_form">
                    <form onSubmit={props.handleSubmit}>
                        <div className="single_article_text_new_comment_name_email">
                            <div className="imput_field_group">
                                {props.errors.user_name && <div className="error">{props.errors.user_name}</div>}
                                <input className="single_article_text_new_comment_name"
                                       type="text"
                                       name="user_name"
                                       placeholder="Введите Ваше Имя"
                                       onChange={props.handleChange}
                                       onBlur={props.handleBlur}
                                       value={props.values.user_name}
                                />
                            </div>
                            <div className="imput_field_group">
                                {props.errors.user_email && <div className="error">{props.errors.user_email}</div>}
                                <input className="single_article_text_new_comment_email"
                                       type="email"
                                       name="user_email"
                                       placeholder="Введите адрес электронной почты"
                                       onChange={props.handleChange}
                                       onBlur={props.handleBlur}
                                       value={props.values.user_email}
                                />
                            </div>
                        </div>
                        <div>
                            <textarea className="single_article_text_new_comment_text"
                                   name="comment"
                                   id="comment"
                                   type="text"
                                   placeholder="Напишите комментарий..."
                                   onChange={props.handleChange}
                                   onBlur={props.handleBlur}
                                   value={props.values.comment}
                            />
                            {props.errors.comment && <div className="error comment_error">{props.errors.comment}</div>}
                        </div>
                        <div className="single_article_text_new_comment_buttons">
                            <button type="submit" className="single_article_text_new_comment_add">Комментировать</button>
                        </div>
                    </form>
                    </div>
                )}

            </Formik>
    );

    const buildSimilarArticles = (content) => {
        if(Array.isArray(content)) {
            content = content.slice(0,3);
           return (
               <div className="similar_feed">
                   <h3>Еще новости</h3>
                   <ol>
                       {content.map((item, index) => (
                           <li>
                               <a onClick={scrolToPageTop} href={'/#/' + section[0] + '/' + item.link}>
                                   <div className="similar_feed_image">
                                       <img src={item.image} alt={item.title} />
                                   </div>
                                   <span>{item.title}</span>
                               </a>
                           </li>
                       ))
                       }
                   </ol>
               </div>
           )
        }
        return '';
    }
    const buildTableOfContent = (content) => {
        if(Array.isArray(content)) {
           return (
               <div className="table_of_content">
                   <h3>Содержание</h3>
                   <ol>
                   {content.map(item => (
                       <li>
                           <NavHashLink smooth to={location.pathname + '#' + item.link}>
                               {item.title}
                           </NavHashLink>
                       </li>
                   ))}
                   </ol>
               </div>
           )
        }
        return '';
    }

    const scrolToPageTop = () => {
        //window.scrollTo(0, 0);
        window.scrollTo({ top: 0, behavior: 'instant' });
    }

    const buildSwiper = (content) => {

        if(Array.isArray(content)) {
           return (
               <div className="container">
                   <div className="similar_swiper_header">
                       <h3>Новости на схожую тематику</h3>
                       <div className="swiper-button-group">
                           <div className="swiper-button-prev" ></div>
                           <div className="swiper-button-next" ></div>
                       </div>
                   </div>
                   <Swiper
                       slidesPerView={3}
                       spaceBetween={30}
                       navigation={{
                           prevEl: '.swiper-button-prev',
                           nextEl: '.swiper-button-next',
                       }}
                       modules={[Navigation, Pagination, Mousewheel, Keyboard]}
                       breakpoints={{
                           320: {
                               slidesPerView: 1,
                               spaceBetween: 20
                           },
                           480: {
                               slidesPerView: 2,
                               spaceBetween: 10
                           },
                           840: {
                               slidesPerView: 3,
                               spaceBetween: 20
                           },
                       }}
                   >
                   {content.map(item => (
                       <SwiperSlide>
                           <a onClick={scrolToPageTop} href={'/#/' + section[0] + '/' + item.link}>
                               <img src={item.image} alt={item.title}/>
                           </a>
                           <span>{item.title}</span>
                       </SwiperSlide>
                   ))}
               </Swiper>
               </div>
           )
        }
        return '';
    }

    return (
        <>
        <div className="single_article" id="page_start">
            <div className="container single_article_block">
                <div className="single_article_body">
                    <div className="single_article_card">
                        <h1 className="single_article_title">{data.title}</h1>
                        <div className="single_article_card_fields">
                            <div className="single_article_card_fields_author">
                                <div>
                                    <div className="single_article_card_fields_author_description">
                                        <div>Опубликовано в </div>
                                        <a href={'#/' + data.cat_slug}> "{data.cat_name}"</a>
                                    </div>
                                </div>
                            </div>
                            <div className="single_article_card_fields_details">
                                <div className="single_article_card_fields_details_reed">
                                    <img src={require('../img/time.svg').default} alt="reed time"/>
                                     {data.reading_time}
                                </div>
                                <div className="single_article_card_fields_details_date"> {data.post_date}</div>
                            </div>
                        </div>
                    </div>
                    <section className="single_article_text">
                        <div className="single_article_text_info">
                            <div className="single_article_text_info_box">
                                <div className="single_article_text_info_views">
                                    <img src={require('../img/eye.svg').default} alt="Vievs"/>
                                    {data.views}
                                </div>
                                <div className="single_article_text_info_comments">
                                    <img src={require('../img/chat.svg').default} alt="Comments count"/>
                                    {data.comment_count}
                                </div>
                            </div>
                            <div className='favorite_btn-col'><button className='favorite_btn'></button></div>
                        </div>

                        <img className="single_article_text_featured_image" src={getPostThumbnail(data.avatar)}></img>
                        <div className="single_article_text_block" dangerouslySetInnerHTML={{__html: checkHTML(data.body)}}></div>
                        <div className="content_separator"></div>
                        <div className="single_article_comments" id="comments" >
                            <div className="single_article_text_comments">
                                <div className="single_article_text_comments_title">Комментарии</div>
                            </div>
                            <div className="single_article_text_new_comment">
                                <img src={require('../img/avatar.png')} alt="Avatar" className="single_article_text_new_comment_avatar"/>
                                {CommentForm()}
                            </div>
                            { buildComments(data.comments) }
                        </div>
                    </section>
                </div>
                <div className="single_article_similar" >
                    <div className="single_article_similar_psts">
                        {buildSimilarArticles(similar_feed)}
                    </div>
                    <div id="side_bar" className="single_article_similar_container">
                        {buildTableOfContent(data.anchor_table)}
                    </div>
                </div>
            </div>
        </div>
        <div className="similar_swiper">
            {buildSwiper(similar_feed)}
        </div>
        </>
    )
}

export default SingleBlogger;